import { InventoryTypeKey } from '@carvana/merch-contracts/InventoryType';
import { blobCdnUrl } from '~/constants/environment';
import PurchaseType from '~/constants/purchaseType';
import { VehicleLockTypeKey } from '~/constants/vehicleLockType';
import {
  useUserPurchasing,
  useVehicleAvailability
} from '~/context/vdp/UserVehicleContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import type { PurchaseEventPayload } from '~/native/common/contracts';
import useIsReservableVehicle from './useIsReservableVehicle';

export default function useVehicleDetailsForNative() {
  const isReservableVehicle = useIsReservableVehicle();
  const vehicle = useGetVehicleDetails();
  const availability = useVehicleAvailability();
  const {
    stockImageData: { jellyBeanMobileUrl = '' } = {},
    stockNumber = 0,
    vexVdpImageData: { heroes: { hero = '' } = {} } = {}
  } = vehicle;

  return {
    ctaAction: availability.action,
    inventoryType: vehicle.inventoryType ?? InventoryTypeKey.Core,
    isLocked: availability.lockType !== VehicleLockTypeKey.None,
    locationId: vehicle.location?.locationId ?? 0,
    lockType: availability.lockType,
    make: vehicle.make ?? '',
    mileage: vehicle.mileage ?? 0,
    model: vehicle.model ?? '',
    price: vehicle.price ?? 0,
    purchaseType: vehicle.purchaseType ?? PurchaseType.Purchasable,
    saleStatus: vehicle.saleStatus ?? '',
    stockNumber,
    trim: vehicle.trim ?? '',
    vehicleId: vehicle.vehicleId ?? 0,
    vehicleImage: isReservableVehicle
      ? jellyBeanMobileUrl
      : hero ||
        `${blobCdnUrl}/${stockNumber}/pre/original/${stockNumber}-edc-03.jpg`,
    year: vehicle.year ?? 0
  };
}

export function useEventPayload(): PurchaseEventPayload {
  const purchasing = useUserPurchasing();
  const {
    inventoryType,
    make,
    model,
    stockNumber,
    trim,
    vehicleId,
    vehicleImage,
    year
  } = useVehicleDetailsForNative();

  return {
    activePurchaseVehicleId: purchasing.vehicle?.vehicleId,
    inventoryType,
    make,
    model,
    stockNumber,
    trim,
    vehicleId,
    vehicleImage,
    year
  };
}
